// removed by extract-text-webpack-plugin
module.exports = {"block-img":"src-templates-article----article-module---block-img---m5Pij","content":"src-templates-article----article-module---content---Vwp2b","showContent":"src-templates-article----article-module---showContent---1MW7c"};


//////////////////
// WEBPACK FOOTER
// ./src/templates/article/article.module.scss
// module id = 312
// module chunks = 195451945045015